import { render, staticRenderFns } from "./HeroRoof.vue?vue&type=template&id=a6c4993c&scoped=true"
import script from "./HeroRoof.vue?vue&type=script&lang=js"
export * from "./HeroRoof.vue?vue&type=script&lang=js"
import style0 from "./HeroRoof.vue?vue&type=style&index=0&id=a6c4993c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c4993c",
  null
  
)

export default component.exports